import React from "react";
import PropTypes from "prop-types";
// import _debounce from "lodash/debounce";
// import _noop from "lodash/noop";
import { DatePicker } from "antd";

const { RangePicker } = DatePicker;

class DateSelect extends React.Component {
    render() {
        const { value, placeholder, ...restProps } = this.props;
        return (
            <RangePicker
                value={value ? value : []}
                placeholder={
                    placeholder && placeholder.length ? placeholder : []
                }
                {...restProps}
            />
        );
    }
}

DateSelect.propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    placeholder: PropTypes.array
};

export default DateSelect;
